import React from "react";
import { STATS, AWARDS } from "../mock";

const Stats = () => {
  return (
    <section className="bg-[#1f1d1a] text-[#f5efe6] py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-10 gap-x-6">
          {STATS.map((s, i) => (
            <div key={i} className="text-center border-r border-[#3a342c] last:border-r-0 md:px-6 reveal">
              <div className="font-display text-5xl md:text-6xl text-[#c9a87c] mb-2 display-tight">{s.value}</div>
              <div className="text-[0.7rem] tracking-[0.3em] uppercase text-[#e8dfc9]/80">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-12 border-t border-[#3a342c] flex flex-col md:flex-row items-center justify-between gap-10">
          <p className="kicker text-[#c9a87c]">Awards &amp; Recognition</p>
          <div className="flex items-center gap-10 flex-wrap justify-center">
            {AWARDS.map((a, i) => (
              <img key={i} src={a.img} alt={a.name} className="h-16 md:h-20 object-contain opacity-95" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
